import { getTicketOptionsFilter } from '@/constants/options/ticket.option';
import { RoleEnum } from '@/types/enums/role.enum';
import type { KeyWithFilter } from '@/utils/filter/filter';

// should set default operator
export const filters: () => KeyWithFilter[] = () => {
    return [
        {
            key: [
                { key: 'name', trans: 'name', defaultOperator: 'like' },
                { key: 'address', trans: 'address', defaultOperator: 'like' },
                { key: 'code', trans: 'code.ticket', defaultOperator: 'like' },
            ],
            type: 'input',
            value: [],
        },
        {
            key: [
                {
                    key: 'createdDate',
                    trans: 'createdDate',
                    defaultOperator: '=',
                },
                {
                    key: 'scheduledTime',
                    trans: 'scheduledTime',
                    defaultOperator: '=',
                },
            ],
            type: 'date',
            value: [],
        },
        {
            key: [
                {
                    key: 'customerId',
                    trans: 'Customers',
                    keyService: 'Customers',
                    defaultOperator: '=',
                    excludeRoles: [RoleEnum.CUSTOMER],
                },
                {
                    key: 'ticketTypeId',
                    trans: 'TicketTypes',
                    keyService: 'TicketTypes',
                    defaultOperator: '=',
                },
            ],
            type: 'orm',
            value: [],
        },
        {
            key: [
                {
                    key: 'ticketStatus',
                    trans: 'ticketStatus',
                    defaultOperator: '=',
                },
            ],
            type: 'select',
            value: getTicketOptionsFilter(),
        },
    ];
};
